<template>
  <div class="pg-expire-top" v-if="!!text">
    <div class="pg-expire-top-t">
      <div class="pg-expire-top-t-l"></div>
      <div class="pg-expire-top-t-text">{{ text }}</div>
      <div class="pg-expire-top-t-l"></div>
    </div>
    <p v-if="expire?.type === 'date'">联系电话：18180479171</p>
  </div>
</template>
<script setup>
import { getCurrentInstance, computed } from 'vue'

const { proxy } = getCurrentInstance()
const expire = computed(() => proxy.$store.state.menuStore.expire)

const text = computed(() => {
  if (expire.value?.strict === 5) {
    return expire.value.message || '您的软件许可证即将到期，请尽快联系商务续费。'
  } else if (expire.value?.strict === 3) {
    return (
      expire.value.message ||
      '您的软件许可证已到期，请及时联系商务续费，否则过期30天之后将无法使用系统。'
    )
  } else {
    return ''
  }
})
</script>
<style lang="scss">
@import '../style/expire-top.scss';
</style>
